module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("The list of people who helped shape this book is long, so apologies to any I have omitted. Amongst those who deserve credit for shaping my writing are Liz Hardy, copy editor from whom I learnt so much, Brad, Gio, Adi and the team at Coretext who taught me a great deal about the power of writing, Janet Lawrence, taken too soon from us and from whom I was fortunate to learn a great deal from. And to Gloria and Denise, to whom this book is dedicated, thanks for your unwavering support and encouragement. Finally to Dad, gone but not forgotten for pushing on this, it meant a lot.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0